const AppConfig = {
  key: {
    LoggedIn: 'loggedInLSXVip'
  }
}

export default AppConfig;
